import {
  CARE_PATHWAYS,
  PATIENT_STATUS,
  THERAPY_DATA_CODE,
  MHC_CODE,
} from '@utils/constants/medicalCodes';

/** endpoints */
export const patientPathwayInstanceEndpoint = '/pathway_instances';
export const patientPathwayTemplatesEndpoint = '/pathway_templates';
export const therapyDataEndpoint = '/therapy_data';
export const therapyDataBPEndpoint = '/therapy_data/blood_pressure';
export const medicalHistoryAndConditionsEndpoint = '/medical_history_and_conditions';
export const bulkMHCSearchEndpoint = '/medical_history_and_conditions/patient_bulk_code_search';
export const bulkTherapyDataSearchEndpoint = '/therapy_data/patient_bulk_code_search';
export const therapyDataSearchEndpoint = '/therapy_data/search';
export const averageOverTimeframeEndpoint = '/therapy_data/blood_pressure/average_over_timeframe';
export const averageBPEndpoint = '/therapy_data/blood_pressure/average';
export const dailyVariabilityEndpoint = '/therapy_data/daily_variability';
export const surveyResponsesSearchEndpoint = '/survey_responses/search';
export const surveyResponsesSearchLinkIdEndpoint = '/survey_responses/search/link_id';
export const patientMetricsEndpoint = '/action_instances/patient_metrics';
export const personsEndpoint = '/persons/';
export const allPatientsTabEndpoint = '/patients';
export const searchDeviceByIdEndpoint = '/device';
export const patientMedicationsEndpoint = 'medications';
export const solutionsPatientsEndpoint = '/solutions/patients';

export const hypertensionOptions = [
  {
    optionLabel: 'Primary Hypertension Stage 1',
    code: MHC_CODE.HTN_PRIMARY_STG_1,
    status: PATIENT_STATUS.ACTIVE,
    value: false,
  },
  {
    optionLabel: 'Primary Hypertension Stage 2',
    code: MHC_CODE.HTN_PRIMARY_STG_2,
    status: PATIENT_STATUS.ACTIVE,
    value: false,
  },
  {
    optionLabel: 'Secondary Hypertension',
    code: MHC_CODE.HTN_SECONDARY,
    status: PATIENT_STATUS.ACTIVE,
    value: false,
  },
  {
    optionLabel: 'White Coat Hypertension',
    code: MHC_CODE.HTN_WHITE_COAT,
    status: PATIENT_STATUS.ACTIVE,
    value: false,
  },
  {
    optionLabel: 'Masked Hypertension',
    code: MHC_CODE.HTN_MASKED,
    status: PATIENT_STATUS.ACTIVE,
    value: false,
  },
];

export const medicationStatusOption = [
  { optionLabel: 'Active titration', code: THERAPY_DATA_CODE.HTN_MED_STATUS },
  { optionLabel: 'Stable medication', code: THERAPY_DATA_CODE.HTN_MED_STATUS },
  { optionLabel: 'Medication naive', code: THERAPY_DATA_CODE.HTN_MED_STATUS },
  { optionLabel: 'HTN medication discontinued', code: THERAPY_DATA_CODE.HTN_MED_STATUS },
];

export const referredConfig = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
  { label: 'Unknown', value: null },
];

export const reasonForEnrollmentChoices = [
  'Suspected white coat hypertension',
  'Suspected masked hypertension',
  'Periodic blood pressure tracking',
  'Other',
];

export const stepsTakenConfig = [
  {
    optionLabel: 'Sleep study',
    value: false,
    code: THERAPY_DATA_CODE.SECONDARY_HTN_DIFFERENTIAL_SLEEP,
  },
  {
    optionLabel: 'Urinalysis',
    value: false,
    code: THERAPY_DATA_CODE.SECONDARY_HTN_DIFFERENTIAL_UA,
  },
  {
    optionLabel: 'Blood chemistry profile',
    value: false,
    code: THERAPY_DATA_CODE.SECONDARY_HTN_DIFFERENTIAL_BCP,
  },
  {
    optionLabel: 'ECG 12 lead',
    value: false,
    code: THERAPY_DATA_CODE.SECONDARY_HTN_DIFFERENTIAL_ECG12,
  },
  {
    optionLabel: 'Complete blood count',
    value: false,
    code: THERAPY_DATA_CODE.SECONDARY_HTN_DIFFERENTIAL_CBC,
  },
];

// TODO: move to medical codes. repurpose this label to be the display param for requests ONLY.
export const mhcLabelMap = {
  [MHC_CODE.HTN_DIAGNOSED]: 'Diagnosed with Hypertension',
  [MHC_CODE.HTN_NOT_DIAGNOSED]: 'Not Diagnosed with Hypertension',
  [MHC_CODE.HTN_PRIMARY_STG_1]: 'Primary hypertension stage 1',
  [MHC_CODE.HTN_PRIMARY_STG_2]: 'Primary hypertension stage 2',
  [MHC_CODE.HTN_SECONDARY]: 'Secondary hypertension',
  [MHC_CODE.HTN_WHITE_COAT]: 'White coat hypertension',
  [MHC_CODE.HTN_MASKED]: 'Masked hypertension',
  [MHC_CODE.DIABETES_HISTORY]: 'Has History of Diabetes',
  [MHC_CODE.SMOKING_CURRENT]: 'Patient is a Current Smoker',
  [MHC_CODE.SMOKING_HISTORY]: 'Has smoking history',
  [MHC_CODE.OSA_HISTORY]: 'Has History of Obstructive Sleep Apea',
  [MHC_CODE.CAD_MI_HISTORY]: 'Has History of Coronary artery disease or heart attack',
  [MHC_CODE.STROKE_TIA_HISTORY]: 'Has History of Stroke or TIA',
  [MHC_CODE.REDUCED_KIDNEY_HISTORY]: 'Has History of Reduced kidney function',
  [MHC_CODE.HF_HISTORY]: 'Has History of Heart Failure',
  [MHC_CODE.HTN_DISORDER_HX]: 'Yes History of hypertensive disorders',
  [MHC_CODE.HTN_DISORDER_NO_HX]: 'No, history of hypertensive disorders',
  [MHC_CODE.GESTATIONAL]: 'Gestational hypertension',
  [MHC_CODE.PREECLAMPSIA]: 'Preeclampsia',
  [MHC_CODE.ECLAMPSIA]: 'Eclampsia',
  [MHC_CODE.HELP_SYNDROME]: 'HELP Syndrome',
  [MHC_CODE.RENAL_PARENCHYMAL_DISEASE]: 'Renal parenchymal disease',
  [MHC_CODE.RENOVASCULAR_DISEASE]: 'Renovascular disease',
  [MHC_CODE.PRIMARY_ALDOSTERONISM]: 'Primary aldosternoism',
  [MHC_CODE.OSA]: 'Obstructive sleep apnea',
  [MHC_CODE.DRUG_ALCOHOL_INDUCED_SECONDARY_HTN]: 'Drug or alcohol induced',
  [MHC_CODE.PPGL]: 'Pheochromocytoma / paraganglioma',
  [MHC_CODE.CUSHINGS_SYNDROME]: `Cushing's Syndrome`,
  [MHC_CODE.HYPOTHYROIDISM]: 'Hypothyroidism',
  [MHC_CODE.HYPERTHYROIDISM]: 'Hyperthyroidism',
  [MHC_CODE.COA_NO_DX_REPAIR]: 'Aortic coarctation (undiagnosed or repaired)',
  [MHC_CODE.PHPT]: 'Primary hyperpara-thyroidism',
  [MHC_CODE.CAH]: 'Congenital adrenal hyperplasia',
  [MHC_CODE.MES_NOT_PRIMARY_ALDOSTERONISM]:
    'Mineralocorticoid excess syndromes other than primary aldosteronism',
  [MHC_CODE.ACROMEGALY]: 'Acromegaly',
};

// TODO: move to medical codes. repurpose this label to be the display param for requests ONLY.
export const therapyDataLabelMap = {
  [THERAPY_DATA_CODE.HTN_MED_STATUS]: `Status of patient's use of hypertension medications`,
  [THERAPY_DATA_CODE.BP_PANEL_AT_ENROLL]: 'Blood Pressure at Enrollment',
  [THERAPY_DATA_CODE.SYSTOLIC_BP_TARGET]: `Patient's target Systolic BP (for display in charts)`,
  [THERAPY_DATA_CODE.SYSTOLIC_BP_AT_ENROLL]: `Patient's systolic blood pressure at time of enrollment`,
  [THERAPY_DATA_CODE.DIASTOLIC_BP_TARGET]: `Patient's target Diastolic BP (for display in charts)`,
  [THERAPY_DATA_CODE.DIASTOLIC_BP_AT_ENROLL]: `Patient's diastolic blood pressure at time of enrollment`,
  [THERAPY_DATA_CODE.CHOLESTEROL_TOTAL]: `Patient's total cholesterol measurement`,
  [THERAPY_DATA_CODE.CHOLESTEROL_HDL]: `Patient's HDL cholesterol measurement`,
  [THERAPY_DATA_CODE.CHOLESTEROL_LDL]: `Patient's LDL cholesterol measurement`,
  [THERAPY_DATA_CODE.HEIGHT_IN]: 'Height (inches)',
  [THERAPY_DATA_CODE.WEIGHT_LB]: 'Weight (lbs)',
  [THERAPY_DATA_CODE.BP_PANEL]: 'Systolic and Diastolic Blood Pressure in mmHG',
  [THERAPY_DATA_CODE.SYSTOLIC_BP]: 'Systolic Blood Pressure in mmHG',
  [THERAPY_DATA_CODE.DIASTOLIC_BP]: 'Diastolic Blood Pressure in mmHG',
  [THERAPY_DATA_CODE.HEART_RATE_BP]:
    'Heart Rate (collected while measuring withings blood pressure)',
  [THERAPY_DATA_CODE.HTN_DX_DURATION_ENROLL]: 'Estimated Hypertension Diagnosis Time at Enroll',
  [THERAPY_DATA_CODE.HTN_LEVEL_OF_CONCERN]:
    'Answer to “How concerned are you about high blood pressure?"',
  [THERAPY_DATA_CODE.RDN_CONS_COMP]: 'Indicates whether the RDN consult',
  [THERAPY_DATA_CODE.RDN_CONS_COMP_DATE]: 'Date when RDN Procedure consult was completed',
  [THERAPY_DATA_CODE.RDN_CONS_SCHED]:
    'Indicates whether the RDN Procedure Consult with Interventional Cardiologist was scheduled',
  [THERAPY_DATA_CODE.RDN_PA_CONF]: 'Whether prior authorization for RDN procedure was confirmed',
  [THERAPY_DATA_CODE.RDN_REFERRED_IC]:
    'Indicates whether patient was referred to an Interventional Cardiologist for RDN',
  [THERAPY_DATA_CODE.RDN_PROC_COMP]: 'Indicates whether the RDN Procedure was completed',
  [THERAPY_DATA_CODE.RDN_PROC_COMP_DATE]: 'Date when RDN procedure was completed',
  [THERAPY_DATA_CODE.RDN_PROC_SCHED]: 'Indicates whether the RDN Procedure was scheduled',
  [THERAPY_DATA_CODE.RDN_PROC_SCHED_DATE]: 'Date when RDN procedure is schedule to take place',
  [THERAPY_DATA_CODE.SECONDARY_HTN_DIFFERENTIAL_SLEEP]: 'Sleep Study',
  [THERAPY_DATA_CODE.SECONDARY_HTN_DIFFERENTIAL_BCP]: 'Blood Chemistry Profile',
  [THERAPY_DATA_CODE.SECONDARY_HTN_DIFFERENTIAL_ECG12]: 'Electrocardiogram 12 Lead',
  [THERAPY_DATA_CODE.SECONDARY_HTN_DIFFERENTIAL_UA]: 'Urinalysis',
  [THERAPY_DATA_CODE.SECONDARY_HTN_DIFFERENTIAL_CBC]: 'Complete Blood Count',
  [THERAPY_DATA_CODE.DATE_OF_OFFICE_VISIT]: 'Date of Office Visit',
  [THERAPY_DATA_CODE.DATE_OF_CHOLESTEROL_LAB_DRAW]: 'Date of Cholesterol Lab Draw',
};

export const secondaryHtnCauseOptions = [
  {
    label: mhcLabelMap[MHC_CODE.RENAL_PARENCHYMAL_DISEASE],
    value: MHC_CODE.RENAL_PARENCHYMAL_DISEASE,
  },
  {
    label: mhcLabelMap[MHC_CODE.RENOVASCULAR_DISEASE],
    value: MHC_CODE.RENOVASCULAR_DISEASE,
  },
  {
    label: mhcLabelMap[MHC_CODE.PRIMARY_ALDOSTERONISM],
    value: MHC_CODE.PRIMARY_ALDOSTERONISM,
  },
  {
    label: mhcLabelMap[MHC_CODE.OSA],
    value: MHC_CODE.OSA,
  },
  {
    label: mhcLabelMap[MHC_CODE.DRUG_ALCOHOL_INDUCED_SECONDARY_HTN],
    value: MHC_CODE.DRUG_ALCOHOL_INDUCED_SECONDARY_HTN,
  },
  {
    label: mhcLabelMap[MHC_CODE.PPGL],
    value: MHC_CODE.PPGL,
  },
  {
    label: mhcLabelMap[MHC_CODE.CUSHINGS_SYNDROME],
    value: MHC_CODE.CUSHINGS_SYNDROME,
  },
  {
    label: mhcLabelMap[MHC_CODE.HYPOTHYROIDISM],
    value: MHC_CODE.HYPOTHYROIDISM,
  },
  {
    label: mhcLabelMap[MHC_CODE.HYPERTHYROIDISM],
    value: MHC_CODE.HYPERTHYROIDISM,
  },
  {
    label: mhcLabelMap[MHC_CODE.COA_NO_DX_REPAIR],
    value: MHC_CODE.COA_NO_DX_REPAIR,
  },
  {
    label: mhcLabelMap[MHC_CODE.PHPT],
    value: MHC_CODE.PHPT,
  },
  {
    label: mhcLabelMap[MHC_CODE.CAH],
    value: MHC_CODE.CAH,
  },
  {
    label: mhcLabelMap[MHC_CODE.MES_NOT_PRIMARY_ALDOSTERONISM],
    value: MHC_CODE.MES_NOT_PRIMARY_ALDOSTERONISM,
  },
  {
    label: mhcLabelMap[MHC_CODE.ACROMEGALY],
    value: MHC_CODE.ACROMEGALY,
  },
];

export const patientHypertensionCarePlanInformationDescriptionCopy = {
  summary:
    'Care plans in the Hypertension Care Platform create a more personalized experience for your patients by only showing those educational materials and surveys that are relevant for how their hypertension is being treated. As an example, a patient who is addressing their hypertension through lifestyle modification only would receive general hypertension educational materials and quality of life surveys, but would not be shown information about renal denervation. The patient\'s care plan can be updated at any time through the "Hypertension information" section of the patient\'s profile.',
  carePlans: 'The Hypertension Care Platform currently supports the following care plans:',
  sectionOne:
    'This care plan has been designed to support patients who have not been formally diagnosed with hypertension, but require remote tracking of their blood pressure',
  sectionOneBold: 'N/A - Not diagnosed with hypertension: ',
  sectionTwo:
    'This care plan has been designed to support patients who are making lifestyle changes to address their hypertension but are not taking medication or being evaluated for renal denervation. These patients do not receive educational materials or surveys regarding medication adherence or renal denervation',
  sectionTwoBold: 'Lifestyle Modification Only: ',
  sectionThree:
    'This care plan has been designed for patients who are taking medication to treat their hypertension in addition to lifestyle changes, but are not being evaluated for renal denervation',
  sectionThreeBold: 'Medical Management: ',
  sectionFour:
    'This care plan has been designed for patients who have been identified by their treating physician as potential candidates for RDN, and is intended to support patient education, care coordination, and referral pathway tracking. In addition, patients receive educational materials and surveys to support the ongoing medical management of their hypertension',
  sectionFourBold: 'Under consideration for RDN: Medical Management: ',
  sectionFive:
    'This care plan has been designed for patients who have been identified by their treating physician as potential candidates for RDN, and is intended to support patient education, care coordination, and referral pathway tracking. Per renal denervation labeling, these patients must have been on medication to treat their hypertension in the past. Since they are not currently on medication, these patients do not receive educational materials or surveys regarding medical management',
  sectionFiveBold: 'Under consideration for RDN: Lifestyle Modification Only: ',
  sectionSix:
    'This care plan has been designed to support patients who have had renal denervation and are currently managing their hypertension through medication. Patients will receive educational materials and surveys regarding medication adherence',
  sectionSixBold: 'Post-RDN: Medical Management: ',
  sectionSeven:
    'This care plan has been designed to support patients who have had renal denervation and are currently managing their hypertension through lifestyle modification. Patients will not receive educational materials and surveys regarding medication adherence',
  sectionSevenBold: 'Post-RDN: Lifestyle Modification Only: ',
};

// NOTE hardcoded values per request by product
export const stepsTakenToRuleOutSecondaryHypertensionDisplayLabels = {
  Secondary_HTN_Differential_Sleep: 'Sleep Study',
  Secondary_HTN_Differential_BCP: 'Blood Chemistry Profile',
  Secondary_HTN_Differential_UA: 'Urinalysis',
  Secondary_HTN_Differential_ECG12: '12-Lead Electrocardiogram',
  Secondary_HTN_Differential_CBC: 'Complete Blood Count',
};

export const diagnosedWithHypertensionOptions = [
  {
    label: 'Yes, hypertension diagnosis',
    value: MHC_CODE.HTN_DIAGNOSED,
  },
  {
    label: 'No hypertension diagnosis',
    value: MHC_CODE.HTN_NOT_DIAGNOSED,
  },
];

export const historyOfHypertensiveDisorders = [
  {
    label: 'Yes, history of hypertensive disorders',
    value: MHC_CODE.HTN_DISORDER_HX,
  },
  {
    label: 'No history of hypertensive disorders',
    value: MHC_CODE.HTN_DISORDER_NO_HX,
  },
];

export const htnDisordersOptions = [
  {
    label: 'Gestational hypertension',
    code: MHC_CODE.GESTATIONAL,
    value: false,
  },
  {
    label: 'Preeclampsia',
    code: MHC_CODE.PREECLAMPSIA,
    value: false,
  },
  {
    label: 'Eclampsia',
    code: MHC_CODE.ECLAMPSIA,
    value: false,
  },
  {
    label: 'HELP Syndrome',
    code: MHC_CODE.HELP_SYNDROME,
    value: false,
  },
];

export const activeTitratedOptions = [
  {
    label: 'Yes, active titration',
    value: 'active titration',
  },
  {
    label: 'No, stable medication',
    value: 'stable medication',
  },
];

export const everBeenOnHtnMedsOptions = [
  {
    label: 'Yes, medication discontinued',
    value: 'medication discontinued',
  },
  {
    label: 'No, medication naive',
    value: 'medication naive',
  },
];

export const evaluatedForRDNOptions = [
  {
    value: 'Yes, not eligible at time of evaluation',
  },
  {
    value: 'Yes, contraindicated',
  },
  {
    value: 'Yes, patient decided not to proceed',
  },
  {
    value: 'No',
  },
];

export const referredForRDNOptions = [
  {
    value: 'Yes',
  },
  {
    value: 'No',
  },
  {
    value: 'Unknown',
  },
];

// performed or referred
export const proceduralistConfig = ({ isPerformed }) => {
  return [
    {
      key: 'firstName',
      label: 'First Name',
      isRequired: true,
      valueType: 'valueString',
      code: isPerformed
        ? THERAPY_DATA_CODE.RDN_PROCEDURALIST_PERFORM_NAME
        : THERAPY_DATA_CODE.RDN_PROCEDURALIST_REFER_NAME,
      helperText: '',
    },
    {
      key: 'lastName',
      label: 'Last Name',
      isRequired: true,
      valueType: 'valueString',
      code: isPerformed
        ? THERAPY_DATA_CODE.RDN_PROCEDURALIST_PERFORM_NAME
        : THERAPY_DATA_CODE.RDN_PROCEDURALIST_REFER_NAME,
      helperText: '',
    },
    {
      key: 'npi',
      label: 'NPI (optional)',
      isRequired: false,
      valueType: 'valueInteger',
      code: isPerformed
        ? THERAPY_DATA_CODE.RDN_PROCEDURALIST_PERFORM_NPI
        : THERAPY_DATA_CODE.RDN_PROCEDURALIST_REFER_NPI,
      helperText: '',
    },
  ];
};

export const carePlanOptions = [
  CARE_PATHWAYS.NOT_DIAGNOSED,
  CARE_PATHWAYS.LIFESTYLE_ONLY,
  CARE_PATHWAYS.MED_MANAGEMENT,
  CARE_PATHWAYS.CONSIDER_RDN_MM,
  CARE_PATHWAYS.CONSIDER_RDN_LIFESTYLE,
  CARE_PATHWAYS.POST_RDN_MM,
  CARE_PATHWAYS.POST_RDN_LIFESTYLE,
];

export const defaultFormData1 = {
  hasHtnDiagnosisCode: '',
  hasHtnDisorderHistoryCode: '',
  htnDisorders: htnDisordersOptions,
  pathway: '',
  pathwayTemplates: [],
  disableNextButton: false,
};

export const defaultFormData2 = {
  htnDiagnosedTypes: hypertensionOptions,
  stepsTaken: stepsTakenConfig,
  secondaryHtnCause: '',
  disableNextButton: false,
};

export const defaultFormData3 = {
  isMedActivelyTitrated: '',
  hasBeenOnHtnMeds: '',
  hasBeenEvaluatedForRDN: '',
  hasBeenReferredForRDN: '',
  rdnProceduralistReferredInfo: {
    firstName: '',
    lastName: '',
    npi: '',
  },
  rdnProceduralistPerformedInfo: {
    firstName: '',
    lastName: '',
    npi: '',
  },
  rdnProcedurePerformedDate: '',
  disableNextButton: false,
  payloads: [],
};

export const defaultObservationsFormData = {
  [THERAPY_DATA_CODE.SYSTOLIC_BP_AT_ENROLL]: {},
  [THERAPY_DATA_CODE.DIASTOLIC_BP_AT_ENROLL]: {},
  [THERAPY_DATA_CODE.CHOLESTEROL_TOTAL]: {},
  [THERAPY_DATA_CODE.CHOLESTEROL_HDL]: {},
  [THERAPY_DATA_CODE.CHOLESTEROL_LDL]: {},
  [THERAPY_DATA_CODE.DATE_OF_CHOLESTEROL_LAB_DRAW]: {},
  [THERAPY_DATA_CODE.DATE_OF_OFFICE_VISIT]: {},
};

const CARETEAM_ROLES = {
  PCP: 'PCP',
  INTERVENTIONAL_CARDIOLOGIST: 'Interventional Cardiologist',
  NURSE: 'Nurse',
  PHARMACIST: 'Pharmacist',
};

export const CareteamRoleOptions = [
  {
    label: 'PCP',
    value: CARETEAM_ROLES.PCP,
  },
  {
    label: 'Interventional Cardiologist',
    value: CARETEAM_ROLES.INTERVENTIONAL_CARDIOLOGIST,
  },
  {
    label: 'Nurse',
    value: CARETEAM_ROLES.NURSE,
  },
  {
    label: 'Pharmacist',
    value: CARETEAM_ROLES.PHARMACIST,
  },
];

export const THERAPY_DATA_SCHEMA_NAMES = {
  PRIMARY_REASON_FOR_ENROLLING: 'PRIMARY_REASON_FOR_ENROLLING',
  BP_PANEL_ENROLL: 'BP_PANEL_ENROLL',
  CHOLESTEROL_TOTAL: 'CHOLESTEROL_TOTAL',
  CHOLESTEROL_HDL: 'CHOLESTEROL_HDL',
  CHOLESTEROL_LDL: 'CHOLESTEROL_LDL',
  DATE_OF_CHOLESTEROL_LAB_DRAW: 'DATE_OF_CHOLESTEROL_LAB_DRAW',
  DATE_OF_OFFICE_VISIT: 'DATE_OF_OFFICE_VISIT',
};

export const OBSERVATION_SCHEMA_NAME_MAP = {
  [THERAPY_DATA_CODE.CHOLESTEROL_TOTAL]: THERAPY_DATA_SCHEMA_NAMES.CHOLESTEROL_TOTAL,
  [THERAPY_DATA_CODE.CHOLESTEROL_HDL]: THERAPY_DATA_SCHEMA_NAMES.CHOLESTEROL_HDL,
  [THERAPY_DATA_CODE.CHOLESTEROL_LDL]: THERAPY_DATA_SCHEMA_NAMES.CHOLESTEROL_LDL,
  [THERAPY_DATA_CODE.DATE_OF_CHOLESTEROL_LAB_DRAW]:
    THERAPY_DATA_SCHEMA_NAMES.DATE_OF_CHOLESTEROL_LAB_DRAW,
  [THERAPY_DATA_CODE.DATE_OF_OFFICE_VISIT]: THERAPY_DATA_SCHEMA_NAMES.DATE_OF_OFFICE_VISIT,
};

export const THERAPY_DATA_CATEGORIES = {
  PRIMARY_REASON_FOR_ENROLLING: 'PRIMARY_REASON_FOR_ENROLLING',
  ENROLLMENT_BLOOD_PRESSURE_PANEL: 'ENROLLMENT_BLOOD_PRESSURE_PANEL',
  CHOLESTEROL: 'CHOLESTEROL',
};
